import { useRef, useState } from "react";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
import { AddConsultantTimeSheet } from "./AddConsultantTimeSheet";
import { ITimesheet } from "../../models/Timesheet";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { RedirectPage } from "./RedirectPage";

export interface IModal {
    singleData: ITimesheet,
    open: boolean,
    po: IPurchaseOrder,
    recent: ITimesheet
}

interface IProps {
    is_Create?: boolean,
    is_Delete?: boolean,
    is_Update?: boolean,
    is_Export?: boolean,
    is_View?: boolean,
    po?: IPurchaseOrder
}

export const ShowTimesheet = (permissions: IProps | IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false, po: {}, recent: {} } as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false, po: {}, recent: {} });
    };

    return (
        (permissions as IProps)?.po !== undefined ? <>
            {permissions.is_Update && <AddConsultantTimeSheet singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} po={modal.po} recent={modal.recent} />}
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload} byConsultant={0} po={(permissions as IProps)?.po || {}}></Table>
            <Toast ref={toast} />
        </> : (
            <>
                <RedirectPage />
            </>
        )
    );
}